import { render, staticRenderFns } from "./openPrintTag2.vue?vue&type=template&id=5f50899a&"
import script from "./openPrintTag2.vue?vue&type=script&lang=js&"
export * from "./openPrintTag2.vue?vue&type=script&lang=js&"
import style0 from "./openPrintTag2.vue?vue&type=style&index=0&id=5f50899a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports